// extracted by mini-css-extract-plugin
export default {"footer__container":"Footer_footer__container__HgS2R","footer__inner":"Footer_footer__inner__VjgAB","email":"Footer_email__LOjS1","sns":"Footer_sns__rPrih"};